module.exports = __webpack_public_path__ + "static/media/yoga.a0192d74.svg";